import React, { Component } from 'react';
import Tabs from "../components/Tabs";
import Footer from './Footer';
import CustomerConfirm from './CustomerConfirm';
import Summary from './Summary';
import Actions from './Actions';
import Information from './Information';
import Close from './Close';
import Config from '../Config'
import Changes from '../components/Changes';
import moment from 'moment';
import Stock from '../overview/Stock'
import ServiceCallValidation from '../components/ServiceCallValidation';
import Login from '../login/Login'

class ServiceCall extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mode:"",
            hasChanges: false       // this boolean is changed by the "Changes" object
        };


        // object that holds all changes that need to be saved
        // this object will eventually be saved as a separate process
        // there may be multiple processes (and thus multiple changes objects) for one servicecall
        this.changes = new Changes(this.props.technicianCode, this.props.technicianName, this);

        this.actionsRef = React.createRef();
        this.closeRef = React.createRef();
        this.tabsRef = React.createRef();

        

        this.selectableProducts = this.props.selectableProducts;
    }
    componentDidMount() {
        // check for a valid order
        this.CheckOrder();
    }

    CheckOrder() {
        if (this.props.current.orders===null) {
            if (this.changes.state.activities.length===0) {
                this.changes.AddActivityHelpdesk("Er is geen order bij deze servicebon verwerkt");
            }
        }
    }
    TabInformation() {
        this.tabsRef.current.selectTab("Klantinformatie");
    }

    TabActions() {
        this.tabsRef.current.selectTab("Acties");
    }
    TabActionsLastContainer() {
        this.tabsRef.current.selectTab("Acties");
        setTimeout(() => { this.actionsRef.current.selectAccordionMain("work") }, 100);
    }
    ActionsPrevious() {
        // check to see on which Container we are in the Actions
        const item = this.actionsRef.current.state.accordionMain;
        if (item === "work") {
            if (this.actionsRef.current.state.mode === "testResponse") {
                // close the testResponse popup
                this.actionsRef.current.goMain();
            } else {
                this.actionsRef.current.selectAccordionMain("additional");
            }
        } else if (item === "additional") {
            this.actionsRef.current.selectAccordionMain("devices");
        } else {
            // on the first container, so jump to information
            this.TabInformation();
        }
    }
    ActionsNext() {
        // check to see on which Container we are in the Actions
        const item = this.actionsRef.current.state.accordionMain;
        if (item === "devices") {
            // on the first accordion, so jump to the next accordion
            this.actionsRef.current.selectAccordionMain("additional");
        } else if (item === "additional") {
            // on the middle accordion, so jump to the next accordion
            this.actionsRef.current.selectAccordionMain("work");
        } else {
            // on the last container, so jump to summary
            if (this.actionsRef.current.state.mode === "testResponse") {
                // the testResponse popup is open, close the testResponse popup
                this.actionsRef.current.goMain();
            } else if (
                (this.changes.state.equipmentAdded.filter(p => !p.item.isHomeAccess).length > 0 ||
                    this.changes.state.equipmentModified.filter(p => p.item && !p.item.isHomeAccess).length > 0)
                &&
                !(this.changes.state.testSeconds > 0)
            ) {
                // PA installed or modified, and test not yet performed, open the testResponse popup
                this.actionsRef.current.openTest();
            } else {
                this.TabSummary();
            }
        }
    }
    TabSummary() {
        this.tabsRef.current.selectTab("Samenvatting");
    }

    TabCustomerConfirm() {
        this.tabsRef.current.selectTab("Klantbevestiging");
    }

    TabClose() {
        this.tabsRef.current.selectTab("Afsluiten");
    }



    closeBon() {
        if (this.state.hasChanges && !window.confirm("Let op, er zijn wijzigingen gedetecteerd en deze worden niet opgeslagen. ")) {
            return;
        }
        this.props.CloseBon();
    }


    save(evt) {
        evt.target.disabled = true;

        var errorMessage = ServiceCallValidation.getError(this.props.current, this.changes);
        if (errorMessage) {
            // some error occured, show it
            evt.target.disabled = false;
            this.closeRef.current.setState({ mode: "saveError", saveError: errorMessage });
            return false;
        }

        // for debugging, enable the next line
        // if (Config.isDev) return;

        this.closeRef.current.setState({ mode: "saving", saveError: null });

        // create a process with the data (ID is not yet known, only when stored to the database)
        const newProcess = { changes: { ...this.changes.state } };
        const postData = { ...this.props.current, processes: [newProcess] };

        // change the datetime for timeStart and timeEnd to prevent timezone changes
        postData.processes[0].changes.timeStart = moment(this.changes.state.timeStart).format("yyyy-MM-DDTHH:mm");
        postData.processes[0].changes.timeEnd = moment(this.changes.state.timeEnd).format("yyyy-MM-DDTHH:mm");

        if (Config.isDev) console.log(postData);

        // post the data first, save pictures in separate step
        const requestOptions = Config.GetBearerPost(postData);
        fetch(Config.DigibonServiceBase + 'save', requestOptions)
            .then(response => {
                if (Config.isDev) console.log(response)
                return response.ok ? response.json() : { status: response.status }
            })
            .then(data => {
                if (Config.isDev) console.log(data);
                if (data.status === 401) {
                    // auth error, relogin required
                    this.setState({mode:"login"});
                } else if (data.isError) {
                    // processed succesfully, but an error was detected, show a message
                    this.closeRef.current.setState({ mode: "saveError", saveError: data.message });
                } else if (data.processId) {

                    // valid and stored succesfully
                    this.setState({ hasChanges: false });

                    // set status of bon to "closed", this will make sure that isFirstSave will change in GetError
                    this.props.current.serviceCall.status=-1;

                    this.changes.Reset();

                    // notify parent object 
                    this.props.current.isFirstSave = false;   // this will prevent that signature can be set again

                    newProcess.id = data.processId;
                    if (!this.props.current.processes) {
                        this.props.current.processes = [newProcess];
                    }
                    else {
                        this.props.current.processes = [...this.props.current.processes, newProcess];
                    }

                    // update state
                    this.closeRef.current.processAdded(newProcess);

                    // now process pictures
                    this.savePictures(data.processId);
                } else {
                    // some error occured
                    this.closeRef.current.setState({ mode: "saveError", saveError: "Er is een onbekende fout opgetreden. Data is niet opgeslagen." });
                }
                evt.target.disabled = false;
            })
            .catch((error) => {
                console.log("error", error);

                this.closeRef.current.setState({ mode: "saveError", saveError: "Data kon niet worden verstuurd, check de verbinding en probeer opnieuw." });
                evt.target.disabled = false;
            });
    }

    async savePictures(processId) {

        this.closeRef.current.setState({ savedPicturesCount: 0, mode: "savingpictures" });

        var index = 0;
        for (const item in this.changes.pictures) {
            //await new Promise(r => setTimeout(r, 2000));        // for debugging
            index++;
            console.log("call save single picture");
            await this.saveSinglePicture(processId, this.changes.pictures[item].data);
            this.closeRef.current.setState({ savedPicturesCount: index });
        }


        // all pictures processed
        this.closeRef.current.setState({ mode: "saved" });

        this.changes.pictures.splice(0, this.changes.pictures.length);  // reset the "new" pictures

    }

    async saveSinglePicture(processId, data) {
        const postData = { data: data };

        const requestOptions = Config.GetBearerPost(postData);



        await fetch(Config.DigibonServiceBase + "process/" + processId + "/savepicture", requestOptions)
            .then(response => { })

            .catch((error) => {
                console.log(error);
                this.closeRef.current.setState({ mode: "saveError", saveError: "Fout bij het opslaan van afbeeldingen" });
            });
    }

    closeAlert() {
        this.setState({ mode: "" });
    }
    getLabelClassBack() {
        if (this.state.hasChanges) return "btn-danger";
        return "btn-success";
    }
    headerClick(e) {
        if (e.ctrlKey) {

            console.log("bon", this.props.current);
            console.log("orders", this.props.current.orders);
            console.log("selectableProducts", this.selectableProducts);
            console.log("changes", this.changes.state);
            console.log("businessPartner", this.props.current.serviceCall.businessPartner);
            console.log("contactpersons", this.props.current.contactPersons);
            console.log("serviceCall", this.props.current.serviceCall);
        }
    }
    tokenExpired(oldToken) {
        this.setState({ mode: "login", oldToken: oldToken });
      }
    reloginSuccess(token, jwtToken) {
        this.setState({ mode:""});
    }


    render() {
        const bon = this.props.current;

        const bp = bon.serviceCall.businessPartner;

        //if (bp.alias)
        var showCustomerInfo = true;
        var showCustomerConfirm = !this.state.cancelServiceCall;

        return (
            <React.Fragment>
                {this.state.mode === "alert" &&
                    <div>
                        <div className="message-back"></div>

                        <div className="message-front">
                            <p>{this.state.message}</p>
                            <button className="btn btn-secondary mt-4" onClick={this.closeAlert.bind(this)}>sluiten</button>
                        </div>
                    </div>
                }

                {
                    this.state.mode === "login" &&
                    <Login loginSuccess={this.reloginSuccess.bind(this)} relogin={true} />
                }

                {this.state.mode === "" &&
                    <div>
                        <div className="description mb-4 row" onClick={this.headerClick.bind(this)}>

                            <div className="col ms-auto">
                                <div><b>{bon.serviceCall.subject}</b></div>
                                <div>{bon.serviceCall.description}</div>
                            </div>
                            <div className="col">
                                <div>Werkbon: {bon.serviceCall.documentNumber} </div>
                                <div>Klantnummer: {bp.cardCode} </div>

                            </div>
                        </div>

                        <div className="werkbon-content">
                            <Tabs ref={this.tabsRef} isDisabled={false}>
                                {showCustomerInfo &&
                                    <div label="Klantinformatie" >
                                        <Information current={bon} changes={this.changes}></Information>
                                        <Footer back={this.closeBon.bind(this)} backLabelClass={this.getLabelClassBack()} next={this.TabActions.bind(this)}></Footer>
                                    </div>
                                }
                                <div label="Acties" >

                                    <Actions ref={this.actionsRef} current={bon}
                                        changes={this.changes} 
                                        selectableProducts={this.selectableProducts}
                                        predefinedTexts={this.props.predefinedTexts}
                                        emergencyCenters={this.props.emergencyCenters}
                                        deviceCodeLists={this.props.deviceCodeLists}
                                        selectedUser={this.props.selectedUser}
                                    ></Actions>
                                    <Footer back={this.closeBon.bind(this)} backLabelClass={this.getLabelClassBack()} previous={this.ActionsPrevious.bind(this)} next={this.ActionsNext.bind(this)}></Footer>
                                </div>
                                <div label="Samenvatting" >
                                    <Summary current={bon} changes={this.changes} ></Summary>
                                    <Footer back={this.closeBon.bind(this)} backLabelClass={this.getLabelClassBack()} previous={this.TabActionsLastContainer.bind(this)} next={this.TabCustomerConfirm.bind(this)}></Footer>
                                </div>
                                {showCustomerConfirm &&
                                    <div label="Klantbevestiging">
                                        <CustomerConfirm current={bon} changes={this.changes} selectableProducts={this.selectableProducts}></CustomerConfirm>
                                        <Footer back={this.closeBon.bind(this)} backLabelClass={this.getLabelClassBack()} previous={this.TabSummary.bind(this)} next={this.TabClose.bind(this)} ></Footer>
                                    </div>
                                }
                                <div label="Afsluiten">
                                    <Close ref={this.closeRef} current={bon} isAdmin={this.props.isAdmin}
                                        changes={this.changes}
                                        notifyTokenExpired={this.tokenExpired.bind(this)}></Close>
                                    <Footer
                                        back={this.closeBon.bind(this)} backLabelClass={this.getLabelClassBack()}
                                        previous={this.TabCustomerConfirm.bind(this)}
                                        next={this.state.hasChanges ? p => this.save(p) : null}
                                        nextLabel="gegevens opslaan" nextLabelClass="btn-success"></Footer>
                                </div>
                                {this.props.isAdmin &&
                                    <div label="Voorraad">
                                        <Stock  selectedUser={this.props.selectedUser}></Stock>

                                    </div>
                                }

                            </Tabs>
                        </div>

                    </div>
                }
            </React.Fragment>
        );
    }
}

export default ServiceCall;
